import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminSettingsApi } from '@/api/admin-settings-api';

/**
 * Hook for managing global debug settings
 */
export function useDebugSettings() {
  const queryClient = useQueryClient();
  
  // Query to fetch debug settings
  const query = useQuery({
    queryKey: ['debugSettings'],
    queryFn: adminSettingsApi.getDebugSettings,
  });
  
  // Mutation to update debug settings
  const mutation = useMutation({
    mutationFn: (enabled: boolean) => adminSettingsApi.updateDebugSettings(enabled),
    onSuccess: () => {
      // Invalidate and refetch the debug settings query after a successful update
      queryClient.invalidateQueries({ queryKey: ['debugSettings'] });
    },
  });
  
  return {
    // Query data and states
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    
    // Mutation function and states
    updateDebugSettings: mutation.mutate,
    isPending: mutation.isPending,
    mutationError: mutation.error,
  };
}
